<h2 mat-dialog-title class="text-lg font-bold mb-1">
  {{ isEditMode ? "Editar Registro" : "Nuevo Registro" }}
</h2>
<mat-dialog-content class="modal-content">

  <form #createForm="ngForm" class="grid grid-cols-2 gap-4">
    <div class="col-span-2">
      <label>Unidad de Medida Alternativa</label>
      <ng-select [(ngModel)]="currentCreateUnit.unitMeasureId" [items]="baseUnitOfMeasuresList" bindLabel="name"
        (ngModelChange)="onUnitMeasureChange($event)" bindValue="_id" [searchable]="true"
        placeholder="Seleccione una unidad de medida" name="unitMeasureId" [appendTo]="'body'" required>
      </ng-select>
    </div>

    <!-- Same mapping as development (c0143773b5) and the integration:
         equivalentQuantity = quantity in the base UoM, quantity = quantity in the alternative UoM,
         conversionFactor = equivalentQuantity / quantity. -->
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Cantidad en {{ nameUnitOfMeasure || 'U.M. Base' }}</mat-label>
      <input matInput type="number" [(ngModel)]="currentCreateUnit.equivalentQuantity" name="equivalentQuantity" min="0"
        required />
    </mat-form-field>
    <mat-form-field appearance="fill" class="col-span-1">
      <mat-label>Equivale a ({{ unitPName || 'Unidad Alternativa' }})</mat-label>
      <input matInput type="number" [(ngModel)]="currentCreateUnit.quantity" name="quantity" min="0" required />
    </mat-form-field>

    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Factor de Conversión</mat-label>
      <input matInput type="text" [value]="conversionFactorDisplay" disabled />
    </mat-form-field>



    <mat-form-field appearance="fill" class="col-span-2">
      <mat-label>Código de Barras</mat-label>
      <input matInput type="text" [(ngModel)]="currentCreateUnit.barcode" name="barcode" />
    </mat-form-field>





    <div class="col-span-2 flex items-center gap-4">
      <!-- Unidad Medida Paralela -->
      <mat-checkbox class="pointer-events-auto flex h-10 min-h-10 items-center" [(ngModel)]="currentCreateUnit.isUMP"
        name="isUMP" [checked]="currentCreateUnit.isUMP" (change)="onCheckboxChange('isUMP')" color="primary">
        Unidad Medida Paralela
      </mat-checkbox>

      <!-- Unidad Medida Venta -->
      <mat-checkbox class="pointer-events-auto flex h-10 min-h-10 items-center"
        [(ngModel)]="currentCreateUnit.isCommercialUom" name="isCommercialUom"
        [checked]="currentCreateUnit.isCommercialUom" (change)="onCheckboxChange('isCommerciaUom')" color="primary">
        Unidad Medida Venta
      </mat-checkbox>
    </div>

  </form>
</mat-dialog-content>
<mat-dialog-actions class="modal-actions flex">
  <button mat-button mat-dialog-close class="align-left">Cancelar</button>
  <button mat-raised-button color="primary" (click)="save()"
    [disabled]="!createForm.valid || isDuplicate || isConversionFactorInvalid" class="justify-end">
    {{ isEditMode ? "Actualizar" : "Guardar" }}
  </button>
</mat-dialog-actions>